export const PING = 'ping';
export const FOLDERS = 'folders';
export const INSTALL_FIRMWARE = 'install-firmware';
export const LONG_WAIT = 'long-wait';
export const ERROR_CODE = 'error-code';
export const MISSING_EXECUTABLE = 'missing-executable';
export const TEMP_FILE = 'temp-file';
export const VERSION = 'version';
